import * as React from 'react'
import { SVGProps, Ref, forwardRef, memo } from 'react'

const SvgWechat = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    ref={ref}
    {...props}
  >
    <g fill="none" fillRule="evenodd">
      <path d="M18.499 10.856a8 8 0 1 0-13.895 5.552l-.599 3.605 3.558-1.528c1.567.521 3.046.651 4.437.39" />
      <path
        d="M10.5 2a9 9 0 0 1 8.999 8.838 1 1 0 0 1-2 .035A7 7 0 1 0 5.34 15.732a1 1 0 0 1 .263.71l-.013.13-.3 1.8 1.877-.806a1 1 0 0 1 .569-.066l.141.036c1.412.47 2.72.585 3.938.357a1 1 0 0 1 .368 1.966c-1.341.251-2.745.18-4.203-.206l-.367-.103L4.4 20.932a1 1 0 0 1-1.394-.973l.013-.11.521-3.145-.086-.104a8.962 8.962 0 0 1-1.948-5.275L1.5 11a9 9 0 0 1 9-9Z"
        fill="currentColor"
        fillRule="nonzero"
      />
      <path
        d="M7.563 10.233A1.13 1.13 0 0 0 8.688 9.1a1.13 1.13 0 0 0-1.126-1.133A1.13 1.13 0 0 0 6.438 9.1a1.13 1.13 0 0 0 1.125 1.133ZM12.063 10.233A1.13 1.13 0 0 0 13.187 9.1a1.13 1.13 0 0 0-1.124-1.133A1.13 1.13 0 0 0 10.937 9.1a1.13 1.13 0 0 0 1.126 1.133Z"
        fill="currentColor"
        fillRule="nonzero"
      />
      <path d="M19.38 19.965A5.25 5.25 0 1 1 21 17.987" />
      <path
        d="M16.25 9.5a6.25 6.25 0 0 1 5.656 8.913 1 1 0 1 1-1.81-.853 4.25 4.25 0 1 0-1.313 1.603 1 1 0 0 1 1.195 1.604A6.25 6.25 0 1 1 16.25 9.5Z"
        fill="currentColor"
        fillRule="nonzero"
      />
      <path d="M21.001 17.986 21.5 21l-2.12-1.035" />
      <path
        d="M20.838 17a1 1 0 0 1 1.124.71l.026.113.499 3.014a1 1 0 0 1-1.326 1.104l-.1-.043-2.12-1.035a1 1 0 0 1 .771-1.842l.108.045.376.184-.181-1.1a1 1 0 0 1 .709-1.124l.114-.026ZM17.844 15.4a.847.847 0 0 1-.844-.85c0-.47.378-.85.844-.85.466 0 .843.38.843.85s-.377.85-.843.85ZM14.469 15.4a.847.847 0 0 1-.844-.85c0-.47.378-.85.844-.85.466 0 .844.38.844.85s-.378.85-.844.85Z"
        fill="currentColor"
        fillRule="nonzero"
      />
    </g>
  </svg>
)

const ForwardRef = forwardRef(SvgWechat)
const Memo = memo(ForwardRef)
export default Memo
